import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractorComponent } from './contractor/contractor.component';
import { ClientComponent } from './client/client.component';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
@Component({
  standalone: true,
  imports: [CommonModule, ContractorComponent, ClientComponent],
  selector: 'app-RFI',
  templateUrl: './RFI.component.html',
  styleUrls: ['./RFI.component.css'],
})
export class RFIComponent implements OnInit {
  projectId: any;
  isContractor: boolean = false;
  org_info: any = localStorage.getItem('org_info')
    ? JSON.parse(localStorage.getItem('org_info') as string)
    : null;
  constructor(
    private rfiService: RfiService,
    private route: ActivatedRoute,
    private router: Router,
    private getProjectIdService: GetProjectIdService
  ) {}
  ngOnInit() {
    this.projectId = this.getProjectIdService.getProjectId();
    this.getProjectAwardedData();
    this.rfiService.loadProjectTypeData$.subscribe(() => {
      // console.log('loadProjectTypeData');
    });
  }
  getProjectAwardedData(): any {
    return this.rfiService.getProjectAwardedData().subscribe({
      next: (data: any) => {
        if (data?.meta?.success) {
          if (data?.data?.contractor_organization_id === this.org_info?.id) {
            this.isContractor = true;
          } else {
            this.isContractor = false;
          }
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }
}
